export default __webpack_public_path__ + "static/media/resturant-menu-theme-3.3eda9192.jpg";